






































































































import Vue from "vue";
import Pulse from "@/components/indicators/Pulse.vue";

export default Vue.extend({
  components: {
    Pulse,
  },
  props: ["source"],
  setup() {
    return {};
  },
});
